export { PlaceholderIcon as PouchDisposeIcon } from "./placeholder";
